import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { GuidedHouseholdReviewOutroLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

const layout = withGuidedHouseholdReviewLayout(GuidedHouseholdReviewOutroLayout, { customButtons: true, fullWidth: true });

export const GuidedHouseholdReviewOutroPageTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={layout}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
      resource={resource}
    />
  );
};

GuidedHouseholdReviewOutroPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
